module.exports = __webpack_public_path__ + "static/media/2019-12.bf92d0f3.png";